import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { Button, Text } from 'pcln-design-system'
import styled from 'styled-components'
import { User } from 'pcln-icons'

const DisplayButton = styled(Button)`
  && {
    display: flex;
    align-items: center;
    border: 1px solid ${props => props.theme.colors[props.borderColor]};
    height: ${props => props.isLargeInput ? '56px' : '46px'};
    padding: 6px;
  }
`

class Display extends React.Component {
  static defaultProps = {
    isControlPanelOpen: false,
    controlPanelRef: null,
    displayButtonProps: {}
  }

  static propTypes = {
    controlPanelRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    error: PropTypes.string,
    isControlPanelOpen: PropTypes.bool.isRequired,
    isLargeInput: PropTypes.bool,
    handleClick: PropTypes.func,
    handleFocus: PropTypes.func,
    toggleIsControlPanelOpenState: PropTypes.func,
    value: PropTypes.string,
    displayButtonProps: PropTypes.object
  }

  handleBodyInteraction = event => {
    const { controlPanelRef } = this.props
    const isValidToClose =
      controlPanelRef &&
      !ReactDOM.findDOMNode(this).contains(event.target) && // not clicked on Display
      !ReactDOM.findDOMNode(controlPanelRef.current).contains(event.target) // not clicked on open panel

    const { isControlPanelOpen, toggleIsControlPanelOpenState } = this.props

    if (isControlPanelOpen && isValidToClose && toggleIsControlPanelOpenState) {
      toggleIsControlPanelOpenState()
    }
  }

  componentDidMount () {
    document.addEventListener('click', this.handleBodyInteraction)
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handleBodyInteraction)
  }

  render () {
    const { error, isControlPanelOpen, isLargeInput, handleClick, handleFocus, value } = this.props
    const borderColorValue = !isControlPanelOpen && error ? 'red' : 'borderGray'

    return (
      <DisplayButton
        id='traveler-selection-readonly-input'
        {...this.props.displayButtonProps}
        type='button'
        color='white'
        width={1}
        onClick={handleClick}
        onFocus={handleFocus}
        borderColor={borderColorValue}
        isLargeInput={isLargeInput}
        aria-expanded={isControlPanelOpen}
        aria-controls='traveler-selection-control-panel'
      >
        <User color='primary' mr={'10px'} size={24} />
        <Text aria-live='polite' aria-atomic='true' regular>{value}</Text>
      </DisplayButton>
    )
  }
}

export default Display
